import React from "react";
import {
  LegacyCard,
  InlineGrid,
  TextField,
  Select,
  Checkbox,
} from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import {
  ButtonNumber,
  SatinNumbers,
  threadContrastColor,
  NameLabelColor,
  } from "../CoatData";
import { useLibrary } from "../LibraryContext";


const MenJacketForm = ({
  form,
  setForm,
  errors,
  baseUrl,
  setApploader,
  conditionalFieldsMap,
  viewOrder
}) => {
  const { fabrics: Fabrics, linings: LiningNumbers } = useLibrary();
  const ValueAllSelect = [...LiningNumbers, ...SatinNumbers, ...Fabrics];
  const handleChange =
    (section, key = null, checkArray = true) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          if (checkArray) {
            value = values[0];
          } else {
            value = values;
          }
        } else {
          value = values;
        }

        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }
        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const jacketFields = [
    {
      label: "Front Button",
      key: "frontButton",
      type: "select",
      options: [
        "2 Button",
        "1 Button",
        "3 Button",
        "3 Button with Roll",
        "4 Button",
        "5 Button",
        "DB 4 with 1 Buttoned",
        "DB 4 with 2 Buttoned",
        "DB 6 with 1 Buttoned",
        "DB 6 with 2 Buttoned",
      ],
    },
    {
      label: "Shoulder Pad",
      key: "shoulderPad",
      type: "select",
      options: ["Thin", "No Pad", "Regular Pad"],
    },
    {
      label: "Bottom Style",
      key: "bottomStyle",
      type: "select",
      options: [
        "Rounded",
        "Straight",
        "Rounded Less Cutaway",
        "Rounded More Cutaway",
      ],
    },
    {
      label: "Lapel Style",
      key: "lapelStyle",
      type: "select",
      options: ["Notch", "Peak", "Shawl", "Arc Shawl"],
    },
    {
      label: "Lapel Width",
      key: "lapelWidth",
      type: "select",
      options: [
        '3 1/4"',
        '2 1/2"',
        '2 3/4"',
        '3"',
        '3 1/2"',
        '3 3/4"',
        '4"',
        '4 1/4"',
        '4 1/2"',
        '4 3/4"',
        '5"',
      ],
    },
    {
      label: "Handmade Lapel Buttonhole",
      key: "handmadeLapelButtonhole",
      type: "select",
      options: ["Yes", "No"],
    },
    {
      label: "Back Vent",
      key: "backVent",
      type: "select",
      options: ["Side with Strap", "Center", "Side with No Strap", "None"],
    },
    {
      label: "Chest Pocket",
      key: "chestPocket",
      type: "select",
      options: ["Welt", "Patch"],
    },
    {
      label: "Lower Pocket",
      key: "lowerPocket",
      type: "select",
      options: [
        "Regular",
        "Regular Slanted",
        "Besom",
        "Besom Slanted",
        "Patch",
      ],
    },
    {
      label: "Ticket Pocket",
      key: "ticketPocket",
      type: "select",
      options: ["No", "Regular", "Regular Slanted", "Besom", "Besom Slanted", "Patch"],
    },
    {
      label: "Chest Pocket Sqaure",
      key: "chestPocketSqaure",
      type: "select",
      options: ["Match Lining", "White", "Other"],
    },
    {
      label: "Contrast",
      key: "contrast",
      type: "select",
      options: [
        "No",
        "Lapel",
        'Lapel Edge (1/4")',
        "Lapel Edge Piping",
        "Tuxedo Wrap",
      ],
    },
    {
      label: "Covered Button",
      key: "coveredButton",
      type: "select",
      options: ["No", "Match Fabric", "Yes"]
    },
    {
      label: "Sleeve Button",
      key: "sleeveButton",
      type: "select",
      options: [
        "4 Kissing",
        "1 Button",
        "2 Kissing",
        "3 Kissing",
        "5 Kissing",
        "2 Button",
        "3 Button",
        "4 Button",
        "5 Button",
      ],
    },
    {
      label: "Lining Style",
      key: "liningStyle",
      type: "select",
      options: ["Full", "1/2 lining", "1/4 lining", "No Lining"],
    },
    {
      label: "Custom Lining",
      key: "customLining",
      type: "select",
      options: ["No", "Yes"],
    },
    {
      label: "Lining Number",
      key: "liningNumber",
      type: "select",
      options: LiningNumbers,
    },
    {
      label: "Button Number",
      key: "buttonNumber",
      type: "select",
      options: ButtonNumber,
    },
    {
      label: "Thread Contrast Lapel Buttonhole",
      key: "threadContrastLapelButtonhole",
      type: "select",
      options: ["No", "Yes"],
    },
    {
      label: "Thread Contrast Sleeve",
      key: "threadContrastSleeve",
      type: "select",
      options: ["No", "Last Sleeve Butthonholes", "All Sleeve Buttonholes"],
    },
    {
      label: "Pick Stitch",
      key: "pickStitch",
      type: "select",
      options: ['.05" Pick', '.25" Pick', '.25" Top', 'No'],
    },
    {
      label: "Name Label Font",
      key: "nameLabelFont",
      type: "select",
      options: [
        "Caligraphy",
        "Times Roman",
        "Block",
        "Script",
        "Bradley",
        "Old English",
        "Custom Upload",
      ],
    },
    {
      label: "Name Label Color",
      key: "nameLabelColor",
      type: "select",
      options: NameLabelColor,
    },
    { label: "Name Label Text", key: "nameLabelText" },
  ];

  const monogramOptions = ["Label Right Side", "Collar Felt"];

  // 3. Add a change handler for monogram checkboxes
  const handleMonogramChange = (label, checked) => {
    setForm((prev) => {
      const updated = checked
        ? [...prev.menjacket.monograms, label]
        : prev.menjacket.monograms.filter((m) => m !== label);

      const updatedDetails = { ...prev.menjacket.monogramDetails };
      if (checked && !updatedDetails[label]) {
        updatedDetails[label] = {
          font: "Calligraphy",
          color: "102 White",
        };
      }
      if (!checked) delete updatedDetails[label];

      return {
        ...prev,
        menjacket: {
          ...prev.menjacket,
          monograms: updated,
          monogramDetails: updatedDetails,
        },
      };
    });
  };

  const handleMonogramFieldChange = (label, key, value) => {
    setForm((prev) => ({
      ...prev,
      menjacket: {
        ...prev.menjacket,
        monogramDetails: {
          ...prev.menjacket.monogramDetails,
          [label]: {
            ...prev.menjacket.monogramDetails[label],
            [key]: value,
          },
        },
      },
    }));
  };


  const multipleFileUpload = async (section, key, files) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("images", files[i]);
    }
    setApploader(true);
    try {
      const res = await fetch(`${baseUrl}/api/files/upload-multiple`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        const uploadedFilename = data.files;
        handleChange(section, key, false)(uploadedFilename);
        setApploader(false);
      } else {
        alert("File upload failed");
      }
    } catch (error) { }
  };

  const handleFileUpload = async (section, key, file) => {
    const formData = new FormData();
    formData.append("image", file);
    setApploader(true);
    try {
      const res = await fetch(`${baseUrl}/api/files/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        const uploadedFilename = data.files;
        handleChange(section, key)(uploadedFilename);
        if (key === "fileimage") {
          handleMonogramFieldChange(section, key, uploadedFilename);
        }
        setApploader(false);
      } else {
        alert("File upload failed");
      }
    } catch (error) { }
  };

  const handleDownload = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = url.split("/").pop() || "download.png";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
    }

  };

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (
            key === "coveredButton" &&
            form[sectionKey]?.contrast === "Tuxedo Wrap"
          ) {
            return null;
          }
          if (type === "select") {
            return (
              <React.Fragment key={key}>
                {key !== "liningNumber" &&
                  key !== "buttonNumber" &&
                  key !== "nameLabelColor" && (
                    <div className="two_culumn">
                      <Select
                        label={label}
                        options={options}
                        value={form[sectionKey]?.[key] || ""}
                        onChange={handleChange(sectionKey, key)}
                        error={errors[sectionKey]?.[key]}
                      />
                      {key === "chestPocketSqaure" &&
                        form[sectionKey]?.[key] === "Other" && (
                          <CustomAutocomplete
                            label="Lining Number "
                            optionsList={LiningNumbers}
                            onChange={handleChange(sectionKey, "chestPocketSqaureOther")}
                            defaultValue={
                              form[sectionKey]?.["chestPocketSqaureOther"] || ""
                            }
                          />
                        )}
                      {key === "contrast" &&
                        form[sectionKey]?.[key] !== "No" && (
                          <CustomAutocomplete
                            label="Fabric / Satin / Lining"
                            optionsList={ValueAllSelect}
                            onChange={handleChange(sectionKey, "contrastSatin")}
                            defaultValue={form[sectionKey]?.["contrastSatin"] || ""}
                          />
                        )}
                      {key === "threadContrastLapelButtonhole" &&
                        form[sectionKey]?.[key] === "Yes" && (
                          <CustomAutocomplete
                            optionsList={threadContrastColor}
                            onChange={handleChange(sectionKey, "threadContrastLapelButtonholeYes")}
                            defaultValue={
                              form[sectionKey]?.[
                              "threadContrastLapelButtonholeYes"
                              ] || ""
                            }
                          />
                        )}
                      {key === "coveredButton" &&
                        form[sectionKey]?.[key] === "Yes" && (
                          <CustomAutocomplete
                            optionsList={ValueAllSelect}
                            label="Fabric / Satin / Lining"
                            onChange={handleChange(sectionKey, "coveredButtonYes")}
                            defaultValue={
                              form[sectionKey]?.[
                              "coveredButtonYes"
                              ] || ""
                            }
                          />
                        )}
                      {key === "threadContrastSleeve" &&
                        (form[sectionKey]?.[key] === "Last Sleeve Butthonholes" ||
                          form[sectionKey]?.[key] ===
                          "All Sleeve Buttonholes") && (
                          <CustomAutocomplete
                            optionsList={threadContrastColor}
                            onChange={handleChange(sectionKey, "threadContrastSleeveColor")}
                            defaultValue={
                              form[sectionKey]?.["threadContrastSleeveColor"] ||
                              ""
                            }
                          />
                        )}
                      {key === "nameLabelFont" &&
                        form[sectionKey]?.[key] === "Custom Upload" && (
                          <input
                            type="file"
                            className="imgUpload"
                            accept=".jpg, .jpeg, .png"
                            key="nameLabelFontFile"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (!file) return;
                              handleFileUpload(
                                sectionKey,
                                "nameLabelFontFile",
                                file
                              );
                            }}
                            error={errors[sectionKey]?.["nameLabelFontFile"]}
                          />
                        )}
                      {viewOrder === 'yes' &&
                        form[sectionKey]?.[key] === "Custom Upload" && (
                          form.menjacket.nameLabelFontFile ? (
                            <img
                              className="image_server"
                              onClick={() => handleDownload(form.menjacket.nameLabelFontFile)}
                              src={form.menjacket.nameLabelFontFile}
                              alt="Mark Russell"
                            />
                          ) : null
                        )}
                      {key === "customLining" &&
                        form[sectionKey]?.[key] === "Yes" && (
                          <>
                            <Select
                              label="Template"
                              options={[
                                { label: "Select template", value: "" },
                                { label: "Repeat", value: "Repeat" },
                                { label: "Photos Straight", value: "Photos Straight" },
                                { label: "Photos Scattered", value: "Photos Scattered" },
                                { label: "1 Large", value: "1 Large" },
                                { label: "1 Large + Side Photos", value: "1 Large + Side Photos" },
                              ]}
                              value={form[sectionKey]?.customLiningTemplate || ""}
                              onChange={handleChange(sectionKey, "customLiningTemplate")}
                              error={errors[sectionKey]?.["customLiningTemplate"]}
                            />
                            <input
                              type="file"
                              className="imgUpload"
                              accept=".jpg, .jpeg, .png"
                              key="customLiningFile"
                              multiple
                              onChange={(e) => {
                                const files = e.target.files;
                                if (!files.length) return;
                                if (files.length > 7) {
                                  alert("You can only upload a maximum of 7 files.");
                                  e.target.value = ""; // Clear the input selection
                                  return; // Stop further processing
                                }
                                multipleFileUpload(
                                  sectionKey,
                                  "customLiningFile",
                                  files
                                );
                              }}
                              error={errors[sectionKey]?.["customLiningFile"]}
                            />
                          </>
                        )}
                      {viewOrder === 'yes' &&
                        label === "Custom Lining" &&
                        form[sectionKey]?.[key] === "Yes" && (
                          <div className="image_server_main">
                            {form.menjacket.customLiningFile.map((file, index) => (
                              <img
                                key={index}
                                className="image_server"
                                onClick={() => handleDownload(file)}
                                src={file}
                                alt="Mark Russell"
                              />
                            ))}
                          </div>
                        )}

                    </div>
                  )}
                {key === "liningNumber" &&
                  !(form[sectionKey]?.customLining === "Yes") &&
                  form[sectionKey]?.liningStyle !== "No Lining" && (
                    <CustomAutocomplete
                      label={label}
                      optionsList={options}
                      onChange={handleChange(sectionKey, key)}
                      defaultValue={form[sectionKey]?.[key] || ""}
                    />
                  )}
                {key === "buttonNumber" &&
                  !(form[sectionKey]?.coveredButton === "Yes" || form[sectionKey]?.coveredButton === "Match Fabric") && (
                    <CustomAutocomplete
                      label={label}
                      optionsList={options}
                      onChange={handleChange(sectionKey, key)}
                      defaultValue={form[sectionKey]?.[key] || ""}
                    />
                  )}
                {key === "nameLabelColor" && (
                  <CustomAutocomplete
                    label={label}
                    optionsList={options}
                    onChange={handleChange(sectionKey, key)}
                    defaultValue={form[sectionKey]?.[key] || ""}
                  />
                )}
              </React.Fragment>
            );
          }
          if (
            key === "nameLabelText" &&
            form[sectionKey]?.nameLabelFont === "Custom Upload"
          ) {
            return null;
          }
          return (
            < TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
      <div className="multiple_option_checkbox">
        <h3>Add Monogram</h3>
        <InlineGrid columns={{ xs: 2, sm: 2, md: 3, lg: 6 }} gap="100">
          {monogramOptions.map((label) => (
            <Checkbox
              key={label}
              label={label}
              checked={form.menjacket.monograms.includes(label)}
              onChange={(val) => handleMonogramChange(label, val)}
            />
          ))}
        </InlineGrid>
      </div>
      {form.menjacket.monograms.map((label, index) => (
        <div
          key={`monogram-${label}-${index}`}
          className="monogram_option_list"
        >
          <h3>{`Monogram Details - ${label}`}</h3>
          <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="400">
            <div>
              <Select
                label="Font"
                options={[
                  "Caligraphy",
                  "Times Roman",
                  "Block",
                  "Script",
                  "Bradley",
                  "Old English",
                  "Custom Upload",
                ]}
                value={form.menjacket.monogramDetails[label]?.font || ""}
                onChange={(val) =>
                  handleMonogramFieldChange(label, "font", val)
                }
              />
              {form.menjacket.monogramDetails[label]?.font ===
                "Custom Upload" ? (
                <input
                  label="Upload Image"
                  className="fileUpload"
                  type="file"
                  name="image"
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    handleFileUpload(label, "fileimage", file);
                  }}
                />
              ) : null}
              {viewOrder === 'yes' && (
                form.menjacket.monogramDetails[label]?.fileimage ? (
                  <img
                    className="image_server"
                    onClick={() => handleDownload(form?.menjacket?.monogramDetails?.[label]?.fileimage || "")}
                    src={form.menjacket.monogramDetails[label].fileimage}
                    alt="Mark Russell"
                  />
                ) : null
              )}
            </div>
            <Select
              label="Color"
              options={NameLabelColor}
              value={form.menjacket.monogramDetails[label]?.color || ""}
              onChange={(val) => handleMonogramFieldChange(label, "color", val)}
            />
            {form.menjacket.monogramDetails[label]?.font !== "Custom Upload" && (
              <TextField
                label={
                  label === "Collar Felt"
                    ? "Collar Felt Text"
                    : "Label Right Side Text"
                }
                value={form.menjacket.monogramDetails[label]?.font !== "Custom Upload" ? form.menjacket.monogramDetails[label]?.text || "" : ""}
                onChange={(val) => handleMonogramFieldChange(label, "text", val)}
              />
            )}
          </InlineGrid>
        </div>
      ))}
    </LegacyCard>
  );

  return renderSection("Men Jacket", jacketFields, "menjacket");
};

export default MenJacketForm;
